import React, { ReactNode, useRef } from "react";
import "./RightHomeComponent.css";
import { FaqModal, FaqModalRef } from "../FaqModal";
import { ModalTermosDeUso } from "../modal/ModalTermsUso/ModelTermosDeUso";
import { ModalRef } from "../../utils/modal";
import BrandLockup from "../BrandLockup/BrandLockup";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

interface RightHomeProps {
  questionSrc: string;
  commentIconSrc?: string;
  cardHomeClass?: string; // Nova propriedade opcional
  children?: ReactNode;
  title?: string;
  description?: string;
}

const RightHomeComponent: React.FC<RightHomeProps> = ({
  questionSrc,
  title,
  description,
  cardHomeClass = "card-home", // Use 'card-home' por padrão se não for fornecido
  children,
}) => {
  const faqModalRef = useRef<FaqModalRef | null>(null);
  const modalTermosDeUsoRef = useRef<ModalRef | null>(null);
  const { pathname } = useLocation();
  // teste

  const openFaq = () => {
    faqModalRef.current?.open();
  };

  const openTermosDeUso = () => {
    modalTermosDeUsoRef.current?.open();
  };

  return (
    <div className="right-home !h-full !overflow-y-scroll !flex !flex-col !justify-between">
      <div className="header-mobile">
        <BrandLockup logoClassName="logo-energiav" />

        <img src={questionSrc} alt="question-esquerda" onClick={openFaq} className="question-lado-direito" />
      </div>

      <div className="header-desktop">
        <img src={questionSrc} alt="question-esquerda" onClick={openFaq} className="question-lado-direito self-start justify-self-start" />
      </div>

      <motion.div
        key={pathname}
        className={`${cardHomeClass}`}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3, stiffness: 260 }}
      >
        <div className="container-title-description-mobile-version">
          <h3 className="h3-custom-mobile">
            <span className="brand-highlight">{title}</span>
          </h3>
          {/* <p className="description-mobile-right">{description}</p> */}
          {description?.split("\n").map((d) => (
            <p key={d} className="description-mobile-right" dangerouslySetInnerHTML={{ __html: d }}></p>
          ))}
        </div>
        {children}
      </motion.div>

      <div className="container-termo-adesao-mobile">
        <p className="termo-adesao-mobile" onClick={() => openTermosDeUso()}>
          Termos de Uso e Polticia de Privacidade
        </p>
      </div>
      <FaqModal ref={faqModalRef} />
      <ModalTermosDeUso ref={modalTermosDeUsoRef} />
    </div>
  );
};

export default RightHomeComponent;
